/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Variable_Details_Copy_SuccessInputs */



/**
* | output |
* | --- |
* | "Variables successfully copied" |
*
* @param {Variable_Details_Copy_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const variable_details_copy_success = /** @type {((inputs?: Variable_Details_Copy_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Variable_Details_Copy_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Variables successfully copied")
	return /** @type {LocalizedString} */ ("Les variables ont été copiées avec succès")
});